/* Common.js
 * In order to add imports to common.js they must be added to:
 * lib/index.js
 * lib/navbar.js
 * lib/header.js
*/

// to support IE9+
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.keys';

import $ from 'zepto';

import './components/legacy/tooltips';
import './components/stickyBanner';
import './components/fileUploader/index';
import './components/loaderSpinner/index';

// main.js
import { expose } from './main';
import './components/fields';
import './components/forms';

import { initNavigation } from './components/navigation';
import './components/modal';

import './components/legacy/PasswordMaskedField';
import './components/accordions';
import './utils';
import './components/legacy/customPulldown/customPulldown';
import './components/legacy/customRadio';
import './components/visibilityManager/index';
import './components/tooltip/index';

Object.assign(window, {
  $,
  Zepto: $,
});

expose({
  initNavigation,
});
